<template>
  <mds-table row-hover>
    <mds-thead>
      <mds-th
        v-for="header in $options.headers"
        :key="header.fieldName"
        :style="header.style"
      >
        {{ header.text }}
      </mds-th>
    </mds-thead>
    <mds-tbody>
      <template
        v-for="(row, index) in jobsCopy"
      >
        <mds-tr
          :key="index"
          :aria-controls="index+1"
          :expanded="!!row.expanded"
          type="expandable"
          @click.native="toggleRow(row)"
        >
          <mds-td
            v-for="(header, i) in $options.headers"
            :key="i"
            :right-aligned="header.align === 'right'"
            :style="header.style"
          >
            <template v-if="header.fieldName === 'status'">
              <state-tag
                :status="row[header.fieldName]"
                :color="getTagColor(row[header.fieldName])"
              />
            </template>
            <template v-else-if="header.fieldName === 'link'">
              <a
                :href="row.link"
                target="_blank"
              >
                {{ row.link | decodeLink }}
              </a>
            </template>
            <template v-else-if="header.fieldName === 'processStartTime' || header.fieldName === 'processEndTime'">
              {{ row[header.fieldName] | formatDate }}
            </template>
            <template v-else-if="header.fieldName === 'indexType' || header.fieldName === 'frequency'">
              {{ row[header.fieldName] | textFormatter }}
            </template>
            <template v-else-if="header.fieldName === 'errorMessage'">
              <template v-if="row[header.fieldName]">
                <mds-button
                  :id="`prompt-trigger-error${index}`"
                  variation="icon-only"
                  icon="open-new"
                  type="button"
                  text="Copy"
                  @click="copyErrorToClipboard(index, row[header.fieldName])"
                />
                <mds-tooltip
                  v-model="copiedError[index]"
                  :triggered-by="`prompt-trigger-error${index}`"
                  :position="['right-center']"
                  class="crawled-documents__tooltip"
                >
                  {{ $t(`collectionPrEcPage.copied`) }}
                </mds-tooltip>
              </template>
            </template>
            <template v-else>
              {{ row[header.fieldName] }}
            </template>
          </mds-td>
        </mds-tr>
         <mds-tr
            v-if="!!row.expanded"
            :key="row.providerId"
            type="container"
          >
            <mds-td :colspan="$options.headers.length">
              <links-table :links="jobLinks" />
            </mds-td>
          </mds-tr>
      </template>
    </mds-tbody>
  </mds-table>
</template>

<script>
import { PROVIDER_EXECUTIONS_HEADERS } from '@/constants/pr-ec.constant';
import { STAGES, STATUS } from '@/constants/status-tags-colors.constant';
import { MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd } from '@mds/data-table';
import { MdsButton } from '@mds/button';
import MdsTooltip from '@mds/tooltip';
import LinksTable from '@/components/collection-pr-ec/table/links/LinksTable';
import StateTag from '@/components/ui/StateTag';
import { formatDate, textFormatter } from '@/utils/global.util';
import { getProviderEcLinksByJobId } from '@/services/api/job.service';
import cloneDeep from 'lodash.clonedeep';
export default {
  name: 'LastJobExecutionsTable',
  components: {
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsButton,
    MdsTooltip,
    StateTag,
    LinksTable,
  },
  filters: {
    formatDate,
    textFormatter,
    decodeLink (url) {
      return decodeURI(url);
    },
  },
  props: {
    filterJobs: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      copied: {},
      copiedError: {},
      jobLinks: [],
      jobsCopy: cloneDeep(this.filterJobs),
    };
  },
  watch: {
    filterJobs: {
      handler (jobs) {
        this.jobsCopy = cloneDeep(jobs);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getTagColor (text) {
      return STAGES[text] || STATUS[text] || '';
    },
    async copyErrorToClipboard (id, text) {
      await navigator.clipboard.writeText(text);
      this.$set(this.copiedError, id, true);
      setTimeout(() => {
        this.$set(this.copiedError, id, false);
      }, 2500);
    },
     async toggleRow (row) {
      if (!row.expanded) {
        const res = await getProviderEcLinksByJobId(row.prEcJobId);
        this.jobLinks = res.data || [];

      }
      const updatedJobs = this.jobsCopy.map((job) => ({ ...job, expanded: job.prEcJobId === row.prEcJobId && !job.expanded }));
      this.jobsCopy = updatedJobs;
    },
  },
  headers: PROVIDER_EXECUTIONS_HEADERS,
};
</script>
